function Timeline(data) {
    this.fields = this.createTimelineFields(data);
}

Timeline.prototype = Object.assign(Timeline.prototype, {
    createTimelineFields(timelineDetails) {
        return (
            timelineDetails &&
            timelineDetails.sectionDetails &&
            timelineDetails.sectionDetails.map(row => this.createRow(row))
        );
    },
    createRow(row) {
        const {
            order,
            priority,
            sectionType,
            mandatory,
            dependentSections,
        } = row;
        return {
            order,
            priority,
            sectionType,
            mandatory,
            dependentSections,
        };
    },
});

export default Timeline;
